<template>
  <div class="sp_user">
    <heade-title :title="title"></heade-title>

    <div class="sp_count">
      <div class="sp_search">
        <el-row type="flex"
                justify="space-between"
                :gutter="10">
          <el-col v-if="$hasPermission('sf-sp/user:user:create')">
            <el-button type="primary"
                       size="small"
                       @click="handelCreate">
              <svg-icon icon-class="add"></svg-icon>&nbsp;&nbsp;Create
            </el-button>
          </el-col>
          <el-col v-if="$hasPermission('sf-sp/user:user:export')">
            <el-button plain
                       size="small"
                       style="margin-right:16px"
                       @click="handleExport">
              <svg-icon icon-class="export"></svg-icon>&nbsp;&nbsp;Export
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex"
                justify="space-between"
                :gutter="10">
          <el-col>
            <el-date-picker size="small"
                            v-model="filter.registerDate"
                            type="daterange"
                            @change="conditionSearch"
                            range-separator="-"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
          <el-col>
            <el-select clearable
                       v-model="filter.status"
                       placeholder="Status"
                       size="small"
                       style="width:100%;"
                       @change="conditionSearch">
              <el-option label="Enabled"
                         :value="0"></el-option>
              <el-option label="Disabled"
                         :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col>
            <el-input type="text"
                      v-model="filter.keyword"
                      placeholder="Name/Email/Phone"
                      size="small"
                      @keyup.enter.native="conditionSearch">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"
                 @click="conditionSearch"
                 style="cursor: pointer;"></i>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button plain
                       size="small"
                       class="button_reset"
                       @click="handelReset">
              <svg-icon class="svg-icon"
                        icon-class="reset"></svg-icon>
            </el-button>
          </el-col>
        </el-row>
      </div>
      <el-row class="user-table-content"
              style="margin-top:8px;"
              v-loading="tableLoading">
        <el-col class="table-content"
                :span="24">
          <el-table class="table customer-no-border-table"
                    :data="tableData"
                    style="width: 100%"
                    tooltip-effect="dark"
                    size="medium"
                    border
                    ref="myTable"
                    :header-cell-style="setHeadeStyle">
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             type="selection"
                             width="55"
                             align="center"></el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Name"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Email"
                             prop="email"></el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Phone"
                             prop="phone">
              <template slot-scope="scope">
                <span>{{getAreaCodePhone(scope.row.areaCode,scope.row.phone ) }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Role">
              <template slot-scope="scope">
                <span>{{roleManage(scope.row.roleId)}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Status"
                             width="120">
              <template slot-scope="scope">
                <span :style="scope.row.status==0?activatedStyle:forzenStyle">{{scope.row.status==0?"Enabled":'Disabled'}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Registration Date"
                             width="150">
              <template slot-scope="scope">
                <span>{{moment(scope.row.createdDate).format('YYYY-MM-DD')}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip
                             :render-header="renderHeader"
                             label="Operation"
                             fixed="right"
                             align="left"
                             width="300">
              <template slot-scope="scope">
                <el-button class="text-btn edit-btn"
                           type="text"
                           @click="handelDetails(scope.row)">Edit</el-button>
                <el-button class="text-btn "
                           type="text pas-btn"
                           @click="resetPassword(scope.row)">Change Password</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col class="pagination"
                :span="24"
                style="text-align:right;">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :page-sizes="pageSizes"
                         :page-size="filter.pageSize"
                         :current-page="filter.pageNumber"
                         :disabled="total < 10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>

    <create-user :userMsg="userMsg"
                 v-if="userMsg.show"
                 @userChildMsg="userChildMsg"
                 :roleInfoList="roleList"></create-user>
    <change-password :passwordMsg="passwordMsg"
                     v-if="passwordMsg.show"
                     @passwordChildMsg="passwordChildMsg"></change-password>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
import { tableMixis } from '@/mixins/tableMixis.js'
import CreateUser from './createUser.vue'
import ChangePassword from './changePassword.vue'
import { getAreaCode } from '@/api/loginApi.js'
import { getUserList, getRolesApi, exportUserApi } from '@/api/userApi.js'
import moment from 'moment'
export default {
  components: { headeTitle, CreateUser, ChangePassword },
  name: 'user',
  mixins: [tableMixis],
  data() {
    return {
      title: 'User',
      filter: {
        keyword: '',
        beginTime: '',
        endTime: '',
        status: undefined,
        registerDate: [],
        pageSize: 10,
        pageNumber: 1,
      },
      defaultFilter: {},
      tableData: [],
      pageSizes: [10, 20, 30, 60, 100],
      total: 0,
      userMsg: {
        title: 'Create',
        show: false,
        row: {},
      },
      passwordMsg: {
        title: 'Change Password',
        show: false,
        row: {},
      },
      tableLoading: false,
      roleList: [],
      activatedStyle: {
        color: '#fff',
        background: '#32C093',
        padding: '0 10px',
        height: '22px',
        borderRadius: '50px',
        display: 'inline-block',
      },
      forzenStyle: {
        color: '#fff',
        background: '#E65050',
        padding: '0 10px',
        height: '22px',
        borderRadius: '50px',
        display: 'inline-block',
      },
    }
  },

  methods: {
    //表头样式
    renderHeader(h, data) {
      return h('span', [
        h(
          'el-tooltip',
          {
            attrs: {
              class: 'item',
              effect: 'dark',
              content: data.column.label,
              placement: 'top',
              color: '#ffffff',
            },
          },
          [h('span', data.column.label)]
        ),
      ])
    },
    //刷新重置
    handelReset() {
      this.filter = JSON.parse(JSON.stringify(this.defaultFilter))
      this.handleSearch(this.filter)
    },

    //获取用户列表
    handleSearch(data) {
      this.tableLoading = true
      let params = JSON.parse(JSON.stringify(data))
      params.beginTime =
        params.registerDate && params.registerDate[0]
          ? params.registerDate[0]
          : undefined
      params.endTime =
        params.registerDate && params.registerDate[1]
          ? params.registerDate[1]
          : undefined
      delete params.registerDate
      getUserList(params)
        .then((res) => {
          this.tableLoading = false
          this.tableData = res.rows
          this.total = res.total
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    //获取国家电话区号
    getContryCode() {
      getAreaCode().then((res) => {
        this.$ls.set('AreaCode', res.rows)
      })
    },
    //获取国家区号
    getAreaCodePhone(areaCode, phone) {
      if ((!areaCode && !phone) || (areaCode && !phone)) return '--'
      const areaCodeList = this.$ls.get('AreaCode')
      if (areaCodeList && areaCodeList.length) {
        const currentAreaCode = areaCodeList.find((item) => {
          return item.id === Number(areaCode)
        })
        if (!areaCode && phone) {
          return phone
        } else if (areaCode && phone) {
          return currentAreaCode.areaCode + ' ' + phone
        } else {
          return '--'
        }
      }
    },

    //打开创建用户页面
    handelCreate() {
      this.userMsg.title = 'Create'
      this.userMsg.show = true
      this.userMsg.row = {}
    },

    //打开详情页
    handelDetails(row) {
      this.userMsg.title = 'Edit'
      this.userMsg.row = row
      this.userMsg.show = true
    },

    //修改密码
    resetPassword(row) {
      this.passwordMsg.show = true
      this.passwordMsg.row = row
    },

    //关闭修改密码页面
    passwordChildMsg(data) {
      this.passwordMsg.show = data.show
      if (data.isSave) {
        this.handleSearch(this.filter)
      }
    },

    //关闭详情页
    userChildMsg(data) {
      this.userMsg.show = data.show
      if (data.isSave) {
        this.handleSearch(this.filter)
      }
    },

    //获取用户角色
    getRoles() {
      getRolesApi().then((res) => {
        this.roleList = res.rows
      })
    },

    //导出
    handleExport() {
      let params = JSON.parse(JSON.stringify(this.filter))
      params.beginTime = params.registerDate[0]
        ? params.registerDate[0]
        : undefined
      params.endTime = params.registerDate[1]
        ? params.registerDate[1]
        : undefined
      delete params.registerDate
      delete params.pageSize
      delete params.pageNumber
      exportUserApi(params).then((res) => {
        const a = document.createElement('a')
        const blob = new Blob([res])
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', 'User List.xlsx')
        a.click()
        URL.revokeObjectURL(objectUrl)
      })
    },
  },

  created() {
    if (!this.$ls.get('AreaCode')) {
      this.getContryCode()
    }
    this.defaultFilter = JSON.parse(JSON.stringify(this.filter))
    this.handleSearch(this.filter)
    this.getRoles()
  },
  mounted() {
    this.$refs.myTable.$el.children[1].style.width = 'calc( 100% - 10px)'
  },
  computed: {
    moment() {
      return moment
    },
    roleManage() {
      let role = ''
      return function (val) {
        this.roleList.filter((item) => {
          if (item.id == val) {
            return (role = item.name)
          }
        })
        return role
      }
    },
  },
}
</script>

<style scoped lang="scss">
.sp_user {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .sp_count {
    width: 100%;
    height: calc(100% - 40px);
    background: #fff;
    padding: 16px 16px 16px;
    /deep/.el-button--mini,
    .el-button--small {
      font-size: 14px;
    }
    .sp_search {
      display: flex;
      justify-content: space-between;

      .button_reset {
        // width: 38px;
        // padding: 9px 12px;
        // display: flex;
        // align-items: center;
        // .svg-icon {
        //   width: 12px;
        //   height: 12px;
        // }
        padding: 0;
        width: 38px;
        height: 32px;
      }
    }
    .user-table-content {
      height: calc(100% - 52px);
      .table-content {
        height: calc(100% - 48px);
        .table {
          height: 100%;
          /deep/.el-table__body-wrapper {
            height: calc(100% - 41px);
            overflow-y: auto;
            overflow-x: auto;
          }
          /deep/.el-table__fixed-right .el-table__fixed-body-wrapper,
          .el-table__fixed-right .el-table__fixed-footer-wrapper,
          .el-table__fixed-right .el-table__fixed-header-wrapper {
            // overflow-y: auto !important;
            height: calc(100% - 41px) !important;
            // pointer-events: none !important;
          }
          .text-btn {
            padding: 0px !important;
          }
          .edit-btn {
            margin-right: 20px;
          }
          .pas-btn {
            margin-left: 0;
          }
        }
      }
      .pagination {
        margin-right: 0 !important;
        .el-pagination {
          height: 48px;
          margin-right: 0px !important;
          padding-right: 0px !important;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          /deep/.el-pagination__editor {
            margin-left: 10px !important;
            padding: 0 !important;
          }
          /deep/.el-pager li.disabled {
            color: #ffffff !important;
          }
        }
      }
    }
  }
}
/deep/.el-table-column--selection .cell {
  padding-right: 8px !important;
}
::v-deep .el-table th.el-table__cell > .cell {
  // word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>